export default "/images/vendor/flag-icons/flags/4x3/ky.svg?5a906dc280c91f7ea01a6dd7f82d19a0";